<template>
  <span
    data-testid="pf-checkbox"
    role="checkbox"
    :aria-checked="ariaCheckedState"
    :aria-disabled="isDisabled"
    :tabindex="isDisabled ? -1 : 0"
    class="obj_checkbox"
    :class="{
      'is_disabled': isDisabled,
    }"
    @keypress.space.prevent="onKeypressSpace"
  />
</template>

<script>
export default {
  name: 'PfCheckbox',

  props: {
    checked: {
      type: Boolean,
      required: true,
    },

    indeterminate: {
      type: Boolean,
      default: false,
    },

    isDisabled: { // read-only: neither focusable nor toggleable, used to show a state the user cannot change
      type: Boolean,
      default: false,
    },
  },

  emits: [ 'click' ],

  computed: {
    ariaCheckedState () {
      if (this.indeterminate) {
        return 'mixed'
      }

      return this.checked
    },
  },

  methods: {
    onKeypressSpace () {
      if (this.isDisabled) {
        return
      }

      this.$emit('click')
    },
  },
}
</script>

<style scoped>
/* Same disabled treatment the other objects use (.obj_button, form-control). */
.obj_checkbox.is_disabled {
  cursor: default;
  opacity: var(--opacity-is-disabled);
}
</style>
